import React, { useState, useEffect, useRef } from "react";
import { Dropdown, Button, Modal } from "antd";
import { withRouter, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import moment from "moment";
import Cookies from "js-cookie";

import { DATE_FORMAT_QUERY } from "../../constants";
import { getTranslation } from "../../utils/helper";
import DefaultContactLocation from "../Forms/Orders/DefaultContactLocation";
import { doCreateMutiOrders } from "../../modules/order/stores/thunk";
import { doDetailRoutePlan } from "../../modules/routePlan/stores/thunk";
import CustomMenu from "../CustomMenu";
import "./RoutePlan.scss";

const RoutePlanMenu = ({ history, routePlan, canEdit }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    visibleModal: false,
    contacts: [],
  });
  const mountedRef = useRef(true);
  const { user } = useSelector(state => state.auth);
  const { isFetching, action, status } = useSelector(state => state.order);
  const setting = user.company;
  const {
    location: { pathname },
  } = history;

  let selectedKey = pathname;

  if (selectedKey.includes("orders")) {
    selectedKey = "/orders";
  } else if (selectedKey.includes("drivers")) {
    selectedKey = "/drivers";
  }
  const deliveryDateQuery = moment(routePlan?.deliveryDate).utc().format(DATE_FORMAT_QUERY);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (action === "create-muti" && status === "succeeded" && mountedRef.current) {
      dispatch(doDetailRoutePlan(routePlan?._id));
    }
  }, [isFetching]);

  useEffect(() => {
    if (routePlan?.orders?.length && Cookies.get("PreAction") === "AddOrdersFromContactList" && mountedRef.current) {
      Cookies.remove("PreAction");
      history.push(`/route-plans/${routePlan?._id}/orders`);
    }
  }, [routePlan]);

  const handleClickAddSingleOrder = () => {
    history.push(
      `/orders/new?redirectUrl=${window.location.pathname}&deliveryDate=${deliveryDateQuery}&routePlanType=${routePlan?.type}&routePlanId=${routePlan?._id}`,
    );
  };

  const handleClickAddFromContactList = () => {
    setState({
      ...state,
      visibleModal: true,
      contacts: [],
    });
  };

  const handleSubmitSelectContact = () => {
    const params = [];
    state.contacts.forEach(contact => {
      params.push({
        deliveryName: contact.name,
        deliveryPhone: contact.phone,
        deliveryTimeStart: contact.startTime,
        deliveryTimeEnd: contact.endTime,
        deliveryDuration: contact.duration,
        deliveryAddress: contact.address,
        deliveryLat: contact.lat,
        deliveryLng: contact.lng,
        requiredSkills: contact.types,
        deliveryNotes: contact.notes,
        load: contact.load,
        fields: contact.fields,
        routePlan: routePlan?._id,
        deliveryDate: deliveryDateQuery,
        routePlanType: "VRP",
      });
    });
    dispatch(doCreateMutiOrders(params));
    handleCancelSelectContact();
    Cookies.set("PreAction", "AddOrdersFromContactList");
  };

  const handleCancelSelectContact = () => {
    setState({
      ...state,
      visibleModal: false,
      contacts: [],
    });
  };

  return (
    <div>
      <CustomMenu className="RoutePlanMenu" selectedKeys={[selectedKey]}>
        {canEdit && (
          <CustomMenu.Item key="/drivers">
            <Link to={`/route-plans/${routePlan?._id}/drivers`}>
              <div className="Title">{getTranslation(setting, "Menu", "Drivers")}</div>
              <div className="Count">({routePlan?.drivers?.length || 0})</div>
            </Link>
          </CustomMenu.Item>
        )}
        <CustomMenu.Item key="/orders">
          <Link to={`/route-plans/${routePlan?._id}/orders`}>
            <div className="Title">{getTranslation(setting, "Menu", "Orders")}</div>
            <div className="Count">({routePlan?.orders?.length || 0})</div>
          </Link>
        </CustomMenu.Item>
        <CustomMenu.Item key="/orders/add" className="add-order">
          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            destroyPopupOnHide={true}
            menu={{
              items: [
                {
                  key: "AddSingleOrder",
                  label: (
                    <Button type="link" className="btn-add-single-order" onClick={handleClickAddSingleOrder}>
                      <ReactSVG className="icon" src="/icons/add-single-order.svg" />
                      {getTranslation(setting, "Orders", "Add Single Order")}
                    </Button>
                  ),
                },
                ...(routePlan?.type === "VRP"
                  ? [
                      {
                        key: "AddFromContactList",
                        label: (
                          <Button
                            type="link"
                            className="btn-add-from-contact-list"
                            onClick={handleClickAddFromContactList}>
                            <ReactSVG className="icon" src="/icons/add-from-contact-list.svg" />
                            {getTranslation(setting, "Orders", "Add From Contact List")}
                          </Button>
                        ),
                      },
                    ]
                  : []),
              ],
            }}>
            <ReactSVG className="icon" src="/icons/add_circle.svg" />
          </Dropdown>
        </CustomMenu.Item>
      </CustomMenu>
      <Modal open={state.visibleModal} onCancel={handleCancelSelectContact} footer={[]} width={992}>
        <DefaultContactLocation
          state={state}
          setState={setState}
          handleCancel={handleCancelSelectContact}
          handleSubmit={handleSubmitSelectContact}
          title="Add Orders from Contact List"
          mutiSelect={true}
        />
      </Modal>
    </div>
  );
};

export default withRouter(RoutePlanMenu);
